import { find } from "lodash";
import React from "react";
import { TApiOrderDetails } from "../../../api/endpoints/Order";
import { TApiServiceCharge } from "../../../api/endpoints/ServiceCharge";
import { TApiServicePackage } from "../../../api/endpoints/ServicePackage";
import { TApiVolumeBand } from "../../../api/endpoints/VolumeBand";
import ServicePackageItem from "./ServicePackageItem";

interface IProps {
  order: TApiOrderDetails;
  volumeBand: TApiVolumeBand;
  servicePackages: Array<TApiServicePackage>;
  serviceCharges: Array<TApiServiceCharge>;
  onChange: (servicePackage: TApiServicePackage) => void;
  value?: TApiServicePackage;
}

const ServicePackagePicker = (props: IProps) => {
  const {
    order,
    servicePackages,
    onChange,
    value,
    volumeBand,
    serviceCharges
  } = props;

  return (
    <div className="service-package-picker">
      <div className="service-package-picker-list">
        {
          servicePackages.map(servicePackage => {
            const serviceCharge = find(
              serviceCharges,
              sc => sc.volume_band_id === volumeBand.id &&
                sc.service_package_id === servicePackage.id
            );

            return (
              <ServicePackageItem
                key={servicePackage.id}
                order={order}
                servicePackage={servicePackage}
                serviceCharge={serviceCharge}
                volumeBand={volumeBand}
                onSelect={onChange}
                selected={servicePackage.id === value?.id}
              />
            )
          })
        }
      </div>
    </div>
  )
}

export default ServicePackagePicker;
